import { Project } from '@/types';
import api from './client/axios';
import {
  ApiResponse,
  ProjectDetail,
  ProjectTypeDetail,
} from '@packages/database/types';

export const createProject = async (
  payload: any, // DTO
): Promise<ProjectDetail> => {
  const response = await api.post<ApiResponse<ProjectDetail>>(
    `/projects`,
    payload,
  );
  return response.data.data!;
};

export const getProjects = async (): Promise<ProjectDetail[]> => {
  const response = await api.get<ApiResponse<ProjectDetail[]>>('/projects');
  return response.data.data!;
};

export const getProjectById = async (projectId: string) => {
  const response = await api.get<ApiResponse<ProjectDetail>>(
    `/projects/${projectId}`,
  );
  return response.data.data;
};

export const getProjectTypeById = async (
  projectTypeId: string,
): Promise<ProjectTypeDetail> => {
  const response = await api.get(`/projects/types/${projectTypeId}`);
  return response.data.projectType;
};

export const getProjectTypeCustomFields = async (
  projectTypeId: string,
): Promise<ProjectTypeDetail> => {
  const response = await api.get(
    `/projects/types/${projectTypeId}/custom-fields`,
  );
  return response.data.data!;
};

export const getProjectTypes = async (): Promise<any> => {
  const response = await api.get('/projects/types');
  return response.data.projectTypes;
};

export const updateProjectType = async (data: any) => {
  const response = await api.patch(
    `/projects/types/${data.projectTypeId}/update`,
    data,
  );
  return response.data;
};

export const updateProject = async (data: any) => {
  const response = await api.patch(`/projects/${data.projectId}/update`, data);
  return response.data;
};

export const createProjectType = async (data: any): Promise<any> => {
  const response = await api.post(`/projects/types`, data);
  return response.data;
};
